import { LoadingOutlined } from '@ant-design/icons';
import { Typography } from 'antd';
import type { ReactNode } from 'react';
import { AotvLogo } from './AotvLogo';

const { Title, Text } = Typography;

export function HoldingMessageScene({
  title = 'Waiting Room',
  message,
  isLoading = false,
  shouldShowLogo = true,
  children,
}: {
  title?: string;
  message?: ReactNode;
  isLoading?: boolean;
  shouldShowLogo?: boolean;
  children?: ReactNode;
}) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '64px 16px',
        textAlign: 'center',
      }}
    >
      {shouldShowLogo && (
        <AotvLogo width="200" style={{ marginBottom: 32 }} />
      )}
      {isLoading && <LoadingOutlined style={{ fontSize: 72, marginBottom: 32 }} />}
      {title && (
        <Title style={{ marginBottom: 12 }}>{title}</Title>
      )}
      {message && (
        <Text style={{ fontSize: 18, maxWidth: 540, display: 'block' }}>
          {message}
        </Text>
      )}
      {children && <div style={{ marginTop: 24 }}>{children}</div>}
    </div>
  );
}
